import { fetchSite } from '../actions/sites';
import loadable from '@loadable/component';
import Loading from '../components/Loader';
import { fetchQuestions } from '../actions/questions';
import { fetchRecommendations } from '../actions/recommendations';

const Enquire = loadable(() => import(/* webpackChunkName: "enquire" */ '../containers/Enquire'), {
  fallback: Loading
});

Enquire.needs = (props, { dispatch }, query) => {
  const site = dispatch(fetchSite(props.params.site));
  const category = query && query.cat ? dispatch(fetchQuestions(query.cat.toLowerCase())) : null;
  const recommendations = dispatch(fetchRecommendations(props.params.site));
  Enquire.preload();
  return Promise.all([site, category, recommendations]);
};

export default Enquire;
